import request from "@/utils/request";

export function getUnreadCountTotal() {
  return request.get("/api/notice/unread/count/total");
}

export function getUnreadCount() {
  return request.get("/api/notice/unread/count");
}

export function getNoticePage(pageNum = 1, pageSize = 10, isRead, type) {
  return request.get("/api/notice/page", {
    params: {
      isRead,
      type,
      pageNum,
      pageSize,
    },
  });
}

export function read(id) {
  return request.put(`/api/notice/read/${id}`);
}

export function readAll(type) {
  return request.put("/api/notice/readAll", null, {
    params: {
      type,
    },
  });
}

export function deleteNotice(id) {
  return request.delete(`/api/notice/delete/${id}`);
}

export function deleteNoticeAll(type) {
  return request.delete("/api/notice/deleteAll", { params: { type } });
}
